<div
  class="light-table"
  [class.condensed]="condensed$ | async">
  <div
    class="light-table-header"
    *ngIf="displayHeader$ | async">
    <div class="header-left">
      <div>
        <span>{{ ("name" | i18n) || "Name" | titlecase }}</span>
      </div>
    </div>
    <div class="header-right">
      {{ ("status" | i18n) || "Status" }}
    </div>
  </div>
  <div
    class="visibility-tracker"
    *ngIf="!(hasEnteredScreen$ | async)"
    (appVisible)="enteredScreen()"
    [appVisibleCheckAgain]="false"></div>
  <app-job-invitee-list-item
    *ngFor="
      let invitee of acceptedInvitees$ | async;
      trackBy: trackInvitee;
      let i = index
    "
    class="light-table-list-item light-table-interactable-item"
    data-cy="booked-user-list-item"
    [invitee]="invitee"
    [job]="(job$ | async) ?? undefined"
    [loggedInCustomer]="(loggedInCustomer$ | async) ?? undefined"
    [count]="(userCounts$ | async)?.get(invitee.userId || '')"
    [totalCount]="(totalCount$ | async) ?? undefined"
    [dropdownMenu]="inviteeMenu"></app-job-invitee-list-item>
  <app-job-invitee-list-item
    *ngFor="
      let invitee of transferredInvitees$ | async;
      trackBy: trackInvitee;
      let i = index
    "
    class="light-table-list-item light-table-interactable-item"
    data-cy="transferred-user-list-item"
    [invitee]="invitee"
    [job]="(job$ | async) ?? undefined"
    [loggedInCustomer]="(loggedInCustomer$ | async) ?? undefined"
    [count]="(userCounts$ | async)?.get(invitee.userId || '')"
    [totalCount]="(totalCount$ | async) ?? undefined"
    [dropdownMenu]="inviteeMenu"></app-job-invitee-list-item>
  <app-job-invitee-list-item
    *ngFor="
      let invitee of availableInvitees$ | async;
      trackBy: trackInvitee;
      let i = index
    "
    class="light-table-list-item light-table-interactable-item"
    data-cy="available-user-list-item"
    [invitee]="invitee"
    [job]="(job$ | async) ?? undefined"
    [loggedInCustomer]="(loggedInCustomer$ | async) ?? undefined"
    [count]="(userCounts$ | async)?.get(invitee.userId || '')"
    [totalCount]="(totalCount$ | async) ?? undefined"
    [dropdownMenu]="inviteeMenu"></app-job-invitee-list-item>
  <app-job-invitee-list-item
    *ngFor="
      let invitee of partiallyAvailableInvites$ | async;
      trackBy: trackInvitee;
      let i = index
    "
    class="light-table-list-item light-table-interactable-item"
    data-cy="partially-available-user-list-item"
    [invitee]="invitee"
    [job]="(job$ | async) ?? undefined"
    [loggedInCustomer]="(loggedInCustomer$ | async) ?? undefined"
    [count]="(userCounts$ | async)?.get(invitee.userId || '')"
    [totalCount]="(totalCount$ | async) ?? undefined"
    [dropdownMenu]="inviteeMenu"></app-job-invitee-list-item>
  <app-job-invitee-list-item
    *ngFor="
      let invitee of openInvitees$ | async;
      trackBy: trackInvitee;
      let i = index
    "
    class="light-table-list-item light-table-interactable-item"
    data-cy="open-user-list-item"
    [invitee]="invitee"
    [job]="(job$ | async) ?? undefined"
    [loggedInCustomer]="(loggedInCustomer$ | async) ?? undefined"
    [count]="(userCounts$ | async)?.get(invitee.userId || '')"
    [totalCount]="(totalCount$ | async) ?? undefined"
    [dropdownMenu]="inviteeMenu"></app-job-invitee-list-item>
  <app-job-invitee-list-item
    *ngFor="
      let invitee of unavailableInvitees$ | async;
      trackBy: trackInvitee;
      let i = index
    "
    class="light-table-list-item light-table-interactable-item"
    [invitee]="invitee"
    [job]="(job$ | async) ?? undefined"
    [loggedInCustomer]="(loggedInCustomer$ | async) ?? undefined"
    [count]="(userCounts$ | async)?.get(invitee.userId || '')"
    [totalCount]="(totalCount$ | async) ?? undefined"
    [dropdownMenu]="inviteeMenu"></app-job-invitee-list-item>
  <app-job-invitee-list-item
    *ngFor="
      let invitee of declinedInvitees$ | async;
      trackBy: trackInvitee;
      let i = index
    "
    class="light-table-list-item light-table-interactable-item"
    [invitee]="invitee"
    [job]="(job$ | async) ?? undefined"
    [loggedInCustomer]="(loggedInCustomer$ | async) ?? undefined"
    [count]="(userCounts$ | async)?.get(invitee.userId || '')"
    [totalCount]="(totalCount$ | async) ?? undefined"
    [dropdownMenu]="inviteeMenu"></app-job-invitee-list-item>
  <app-job-invitee-list-item
    *ngFor="
      let invitee of workingInvitees$ | async;
      trackBy: trackInvitee;
      let i = index
    "
    class="light-table-list-item light-table-interactable-item"
    data-cy="working-user-list-item"
    [invitee]="invitee"
    [job]="(job$ | async) ?? undefined"
    [loggedInCustomer]="(loggedInCustomer$ | async) ?? undefined"
    [count]="(userCounts$ | async)?.get(invitee.userId || '')"
    [totalCount]="(totalCount$ | async) ?? undefined"
    [dropdownMenu]="inviteeMenu"></app-job-invitee-list-item>
  <app-job-invitee-list-item
    *ngFor="
      let invitee of canceledInvitees$ | async;
      trackBy: trackInvitee;
      let i = index
    "
    class="light-table-list-item light-table-interactable-item"
    [invitee]="invitee"
    [job]="(job$ | async) ?? undefined"
    [loggedInCustomer]="(loggedInCustomer$ | async) ?? undefined"
    [count]="(userCounts$ | async)?.get(invitee.userId || '')"
    [totalCount]="(totalCount$ | async) ?? undefined"
    [dropdownMenu]="inviteeMenu"></app-job-invitee-list-item>
</div>

<mat-menu
  #inviteeMenu="matMenu"
  class="fixed-icon-mat-menu">
  <ng-template
    matMenuContent
    let-invitee="invitee">
    <ng-container *ngIf="(job$ | async)?.status == jobStatusEnum.OPEN">
      <button
        mat-menu-item
        type="button"
        (click)="bookUser(invitee)"
        *ngIf="
          [
            inviteeStatusEnum.AVAILABLE,
            inviteeStatusEnum.PARTIAL_AVAILABLE,
            inviteeStatusEnum.POSSIBLE_CANDIDATE
          ].includes(invitee.status) &&
          (((loggedInCustomer$ | async)?._id !== (job$ | async)?.customer?.id &&
            (transfer$ | async)?.preventDirectAccept &&
            inviteeStatusEnum.AVAILABLE === invitee.status) ||
            (loggedInCustomer$ | async)?._id === (job$ | async)?.customer?.id ||
            !(transfer$ | async)?.preventDirectAccept)
        "
        data-cy="accept-invitee">
        <ng-container
          *ngIf="
            (loggedInCustomer$ | async)?._id === (job$ | async)?.customer?.id ||
            !(transfer$ | async)?.preventDirectAccept
          ">
          <mat-icon
            svgIcon="star"
            class="book"></mat-icon>
          <span>{{ ("book" | i18n) || "buchen" | titlecase }}</span>
        </ng-container>
        <ng-container
          *ngIf="
            (loggedInCustomer$ | async)?._id !== (job$ | async)?.customer?.id &&
            (transfer$ | async)?.preventDirectAccept &&
            inviteeStatusEnum.AVAILABLE === invitee.status
          ">
          <mat-icon
            svgIcon="star-check-outline"
            class="setToAvailable"></mat-icon>
          <span>{{
            ("submitAsPossibleCandidate" | i18n) || "Kandidat einreichen"
          }}</span>
        </ng-container>
      </button>
      <button
        mat-menu-item
        type="button"
        (click)="reAskInvitee(invitee)"
        *ngIf="invitee.status == inviteeStatusEnum.OPEN"
        data-cy="reask-invitee">
        <mat-icon svgIcon="update"></mat-icon>
        <span>{{ ("reask" | i18n) || "Erneut anfragen" }}</span>
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="
          invitee.status !== inviteeStatusEnum.AVAILABLE &&
          invitee.status !== inviteeStatusEnum.PARTIAL_AVAILABLE &&
          invitee.status !== inviteeStatusEnum.BOOKED
        "
        (click)="overrideInviteeStatus(inviteeStatusEnum.AVAILABLE, invitee.id)"
        data-cy="set-invitee-available">
        <mat-icon
          svgIcon="check"
          class="setToAvailable"></mat-icon>
        <span>{{ ("setToAvailable" | i18n) || "Auf verfügbar setzen" }}</span>
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="
          invitee.status !== inviteeStatusEnum.UNAVAILABLE &&
          invitee.status !== inviteeStatusEnum.BOOKED
        "
        (click)="
          overrideInviteeStatus(inviteeStatusEnum.UNAVAILABLE, invitee.id)
        "
        data-cy="set-invitee-unavailable">
        <mat-icon
          svgIcon="close"
          class="setToUnavailable"></mat-icon>
        <span>{{
          ("setToUnavailable" | i18n) || "Auf nicht verfügbar setzen"
        }}</span>
      </button>
      <button
        mat-menu-item
        type="button"
        (click)="openDeclineInviteeDialog(invitee.id)"
        *ngIf="
          ![
            inviteeStatusEnum.BOOKED,
            inviteeStatusEnum.DECLINED,
            inviteeStatusEnum.CANCELED
          ].includes(invitee.status)
        "
        data-cy="decline-invitee">
        <mat-icon
          svgIcon="close-circle"
          class="decline"></mat-icon>
        <span>{{ ("decline" | i18n) || "ablehnen" | titlecase }}</span>
      </button>
    </ng-container>
    <button
      mat-menu-item
      type="button"
      *ngIf="
        (loggedInCustomer$ | async)?.enableInviteeTransfer &&
        invitee.status === inviteeStatusEnum.BOOKED &&
        invitee.customer?.id === (loggedInCustomer$ | async)?._id &&
        ((loggedInCustomer$ | async)?._id === (job$ | async)?.customer?.id ||
          (job$ | async)?.ownerCustomerIds?.includes(
            (loggedInCustomer$ | async)!._id
          ))
      "
      (click)="transferAcceptedInvitee(invitee.userId || '')"
      data-cy="transfer-invitee">
      <mat-icon
        svgIcon="swap"
        class="transfer"></mat-icon>
      <span>{{ ("transferInvitee" | i18n) || "umbuchen" | titlecase }}</span>
    </button>
    <button
      mat-menu-item
      type="button"
      *ngIf="invitee.status === inviteeStatusEnum.BOOKED"
      (click)="cancelAcceptedInvitee(invitee.userId, invitee.id)"
      data-cy="cancel-invitee">
      <mat-icon
        svgIcon="star-off"
        class="cancel"></mat-icon>
      <span>{{ ("cancelJob" | i18n) || "stornieren" | titlecase }}</span>
    </button>
  </ng-template>
</mat-menu>
